<template>
  <router-view v-if="signedIn"></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~perfect-scrollbar/css/perfect-scrollbar.css';
@import '~socicon/css/socicon.css';
@import '~@fortawesome/fontawesome-free/css/all.css';
@import '~line-awesome/dist/line-awesome/css/line-awesome.css';
@import 'assets/plugins/flaticon/flaticon.css';
@import 'assets/plugins/flaticon2/flaticon.css';
@import 'assets/plugins/keenthemes-icons/font/ki.css';

// Main demo style scss
@import 'assets/sass/style.vue';

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/
@import './../node_modules/@vueform/vueform/dist/vueform.css';

 

</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from '@/core/services/store/config.module';
import { SET_PARAMS } from '@/core/services/store/setting.module';
import { GET_PERMISSIONS } from '@/core/services/store/auth.module';
import { PERMISSION_TYPE } from '@/core/plugins/constants';
import intersection from 'lodash/intersection';
import Vue from 'vue';
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

export default {
  name: 'MetronicVue',
  data() {
    return {
      signedIn: false,
    };
  },
  methods: {
    async handleStorage() {
      await this.delay(2000);
      const permissions = localStorage.getItem('permissions');
      if (!permissions) return this.$mgr.signOut();
    },
    handleForbidden(event) {
      const msg = event.detail?.message || 'Bạn không có quyền thực hiện chức năng này';
      this.$toastr.e(msg, 'Không có quyền');
    },
    handleSessionExpired(event) {
      const msg = event.detail?.message || 'Phiên đăng nhập đã hết hạn';
      this.$toastr.e(msg, 'Hết phiên đăng nhập');
    },
    checkCurrentRoutePermission() {
      const route = this.$route;
      if (!route) return;
      const { pageCode, permissions: required } = route.meta || {};
      if (!pageCode || !required?.length) return;
      const storedPerms = this.$store.state.auth.permissions || [];
      const userPerms = storedPerms.find((p) => p.code === pageCode)?.value?.map((v) => v.nameType) || [];
      if (!intersection(required, userPerms).length) {
        const PERM_NAMES = {
          [PERMISSION_TYPE.VIEW]: 'Xem',
          [PERMISSION_TYPE.INSERT]: 'Tạo mới',
          [PERMISSION_TYPE.UPDATE]: 'Cập nhật',
          [PERMISSION_TYPE.DELETE]: 'Xóa',
          [PERMISSION_TYPE.ASSIGN]: 'Gán dữ liệu',
        };
        const missing = required.filter((p) => !userPerms.includes(p)).map((p) => PERM_NAMES[p] || p).join(', ');
        window.dispatchEvent(new CustomEvent('api:forbidden', { detail: { message: `Bạn thiếu quyền [${missing}] để truy cập trang này` } }));
        this.$router.replace('/').catch(() => {});
      }
    },
  },
  created() {
    window.addEventListener('storage', this.handleStorage);
    window.addEventListener('api:forbidden', this.handleForbidden);
    window.addEventListener('api:session-expired', this.handleSessionExpired);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorage);
    window.removeEventListener('api:forbidden', this.handleForbidden);
    window.removeEventListener('api:session-expired', this.handleSessionExpired);
  },
  mounted() {
    this.$mgr.getSignedIn().then(async (signIn) => {
      this.signedIn = signIn;
      if (signIn) {
        this.$store.dispatch(SET_PARAMS);
        await this.$store.dispatch(GET_PERMISSIONS);
        this.checkCurrentRoutePermission();
      }
    });
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  },
};
</script>
